import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Loader from "../component/layout/Loader/Loader";

const AuthenticatedRoute = ({ children }) => {
  const { isAuthenticated, user, loading } = useSelector((state) => state.user);
  const location = useLocation();

  // Wait for App's initial loadUser request before deciding whether to redirect.
  if (loading) {
    return <Loader />;
  }

  if (!isAuthenticated || !user) {
    return <Navigate to="/Login" state={{ from: location }} replace />;
  }

  return children;
};

export default AuthenticatedRoute;
